import PropTypes from 'prop-types'
import React from 'react'
import classes from './RecurringOrders.scss'
import Button from 'components/Button'
import List from 'components/List'

export const RecurringOrders = (props) => {
  const data = props.recurring_orders.map((recurring_order, index) => ({
    link: `/recurring_orders/${recurring_order.id}/edit`,
    data: [
      recurring_order.id,
      recurring_order.name
    ]
  }))
  const headers = [
    'id',
    'name'
  ]

  return (
    <div className={classes['collection']}>
      <header className={classes['header']}>
        <div className={classes['header-title']}>
          Browsing Recurring Orders
          <span className={classes['header-title--unimportant']}> – {props.recurring_orders.length}</span>
        </div>

        <div className={classes['header-buttons']}>
          <Button options={['green', 'small']} element='a' href='/recurring_orders/new'>
            Add Recurring Order
          </Button>
        </div>
      </header>

      <List data={data} headers={headers} />
    </div>
  )
}

RecurringOrders.propTypes = {
  recurring_orders: PropTypes.array.isRequired
}

RecurringOrders.defaultProps = {
  recurring_orders: []
}

export default RecurringOrders



// WEBPACK FOOTER //
// ./src/components/RecurringOrders/RecurringOrders.js